/* jshint browser:true, node:true, strict:true, noempty:true, noarg:true, eqeqeq:true, browser:true, bitwise:true, curly:true, undef:true, nonew:true, forin:true */
/* globals modules: true, google: true */
import App from '../app';

require('publicPath');
const $ = require('jquery');

const app = new App();
require('jpolo');

window.initMap = function () {
  const $map = $('#map').jPolo({
    zoom: 16,
    center: new google.maps.LatLng(
      window._sharedData.entry_data.coords[0],
      window._sharedData.entry_data.coords[1]
    ),
    panControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },

    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER,
    },
  });

  $map.jPolo('addMarker', {
    style: google.maps.ZoomControlStyle.SMALL,
    position: new google.maps.LatLng(
      window._sharedData.entry_data.coords[0],
      window._sharedData.entry_data.coords[1]
    ),
  });
};

// dynamically add your map
const tag = document.createElement('script');
tag.src =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyC1q1qhOG6Sc2YySgvUs90LsmFwPeJLvyc&callback=initMap';
tag.defer = true;
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
